import { render, staticRenderFns } from "./customerSet.vue?vue&type=template&id=6b03949e&scoped=true&"
import script from "./customerSet.vue?vue&type=script&lang=js&"
export * from "./customerSet.vue?vue&type=script&lang=js&"
import style0 from "./customerSet.vue?vue&type=style&index=0&id=6b03949e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b03949e",
  null
  
)

export default component.exports